<app-loader-2 *ngIf="!(post | async)"></app-loader-2>
<app-post *ngIf="!!(post | async)" [post]="post | async" [ctx]="ctx"></app-post>
